import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal"
import { SecaoButao } from "../../../../components/formulario/styled"
import SearchInput from "../../../../components/inputs/searchInput"
import ModalExportar from "../../../../components/modalExportar"
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf"
import { useServicesMensagens } from "../context/getMembros"
import ModalIncluirMensagem from "./buttons/menuAdd"


export const HeaderMensagem = () => {

  const { getSearchName, listAll } = useServicesMensagens()

  return (
    <>
      <SecaoButao style={{ marginBottom: 5 }}>
        <section style={{ display: 'flex', gap: 5 }}>
          <ModalExportar
            callDownloadExcel={() => OpenExcelUniversal(listAll, ["Ministério", "Tipo", "Frequência", "Mensagem", "Link Youtube"])}
            callDownloadPdf={() => DonwloadPdf(listAll, ["Ministério", "Tipo", "Frequência", "Mensagem", "Link Youtube"],
              ["ministerioGrupo", "tipo", "frequencia", "mensagem", "link"], listAll?.length, [], `${listAll?.length}`)
            }
          />
        </section>
        <SearchInput placeholder="Procure por nome" onChange={getSearchName} />
        <section />
        <section>
          <ModalIncluirMensagem/>
        </section>
      </SecaoButao>
    </>
  )
}

